import goods from "./modules/goods";
import order from "./modules/order";
import pay from "./modules/pay";
export default {
  goods,
  order,
  pay
};
